/** @format */

import { Component, Input, OnChanges } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Review } from '@product-reviews/data-access';
import { SplitContentPipe } from '../pipes/split-content.pipe';

@Component({
	selector: 'product-reviews-review-features',
	templateUrl: './review-features.component.html',
	styleUrl: './review-features.component.scss',
	imports: [CommonModule, SplitContentPipe]
})
export class ReviewFeaturesComponent implements OnChanges {
	@Input() review: Review;
	@Input() filterByUsedFor = false;
	@Input() smallFontFamily = false;
	features: string[] = [];

	ngOnChanges() {
		this.parseReviewContextDataValues();
	}

	private parseReviewContextDataValues(): void {
		this.features = [];
		this.review.ContextDataValuesOrder?.filter((key) =>
			this.filterByUsedFor ? key === 'UsedFor' : key !== 'UsedFor'
		)?.map((key) => {
			const item = this.review.ContextDataValues[key];
			const dimensionLabel = !this.filterByUsedFor ? `${item?.DimensionLabel}: ` : '';
			if (dimensionLabel && item.ValueLabel) {
				this.features.push(`${dimensionLabel}${item.ValueLabel}`);
			}
		});
	}
}
